export const vibrationRequirementStr = (requirement: VibrationRequirement): string => {
  const exportStringLookup: Record<VibrationRequirement, string> = {
    NoDemands: 'keine Anforderungen',
    LowerDemands: 'mittlere Anforderungen (Decken innerhalb einer Nutzungseinheit)',
    HighDemands: 'höhere Anforderungen (Decken zwischen unterschiedlichen Nutzungseinheiten)',
  }

  if (requirement in exportStringLookup) {
    return exportStringLookup[requirement]
  } else {
    return 'unbekannte Anforderungen'
  }
}

export const vibrationScreedRequiredStr = (requirement: VibrationRequirement): string => {
  const exportStringLookup: Record<VibrationRequirement, string> = {
    NoDemands: 'keine konstruktiven Anforderungen',
    LowerDemands:
      'schwimmender Nassestrich oder schwimmender Trockenestrich auf schwerer Schüttung',
    HighDemands: 'schwimmender Nassestrich auf schwerer Schüttung',
  }

  if (requirement in exportStringLookup) {
    return exportStringLookup[requirement]
  } else {
    return 'unbekannte Anforderungen'
  }
}

export const vibrationScreedDataStr = (screedData: ScreedData): string => {
  const screed = screedData.screed
  const fill = screedData.fill

  const screedLookup: Record<ScreedType, string> = {
    NoScreed: 'kein Estrich',
    LightScreed: 'schwimmender Trockenestrich',
    HeavyScreed: 'schwimmender Nassestrich',
  }

  let screedString: string
  if (screed in screedLookup) {
    screedString = screedLookup[screed]
  } else {
    screedString = 'unbekannter Estrich'
  }

  const fillLookup: Record<'NoFill' | 'LightFill' | 'HeavyFill', string> = {
    NoFill: 'keine Schüttung',
    LightFill: 'leichte Schüttung',
    HeavyFill: 'schwere Schüttung',
  }

  let fillString: string
  if (fill in fillLookup) {
    fillString = fillLookup[fill as keyof typeof fillLookup]
  } else {
    fillString = 'unbekannte Schüttung'
  }

  return screedString + ', ' + fillString
}

export const vibrationCheckStatusStr = (checkStatus: VibrationCheckStatus): string => {
  const exportStringLookup: Record<VibrationCheckStatus, string> = {
    AcceptedByFrequency: 'Frequenz, Steifigkeit und konstruktive Anforderungen eingehalten',
    AcceptedByFrequencyAndAcceleration:
      'Frequenz und Beschleunigung in genauerer Untersuchung eingehalten',
    AcceptedByNoRequirements: 'eingehalten, da keine Anforderungen',
    DeniedByNaturalFrequency: 'Eigenfrequenz zu klein',
    DeniedByAcceleration: 'Beschleunigung bei genauerer Untersuchung zu groß',
    DeniedByStiffness: 'Steifigkeit zu gering',
    DeniedByScreed: 'konstruktive Anforderungen nicht eingehalten',
  }

  if (checkStatus in exportStringLookup) {
    return exportStringLookup[checkStatus]
  } else {
    return 'unbekannter Status'
  }
}

export const computeFieldStiffnessDetails = (
  stiffnessDetails: VibrationStiffnessDetails,
): VibrationFieldStiffnessDetails[] => {
  const {
    bending_stiffnesses_l,
    bending_stiffnesses_b,
    span_lengths,
    effective_widths,
    support_stiffnesses,
    screed_stiffnesses,
    member_stiffnesses_l,
  } = stiffnessDetails

  const maxLength = Math.max(
    bending_stiffnesses_l?.length || 0,
    bending_stiffnesses_b?.length || 0,
    span_lengths?.length || 0,
    effective_widths?.length || 0,
    support_stiffnesses?.length || 0,
    screed_stiffnesses?.length || 0,
    member_stiffnesses_l?.length || 0,
  )

  return Array.from({ length: maxLength }, (_, index) => ({
    bending_stiffness_l: bending_stiffnesses_l?.[index] ?? 0,
    bending_stiffness_b: bending_stiffnesses_b?.[index] ?? 0,
    span_length: span_lengths?.[index] ?? 0,
    effective_width: effective_widths?.[index] ?? 0,
    support_stiffness: support_stiffnesses?.[index] ?? [],
    screed_stiffness: screed_stiffnesses?.[index] ?? 0,
    member_stiffness_l: member_stiffnesses_l?.[index] ?? 0,
  }))
}
